import {useEffect} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import { Card4 } from '../../../../partials/content/cards/Card4'



const ModalVersion = ( props:any ) => {
  /*********************************Constantes**************************************** */
 



  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

 
  return (
    
    <>
    {props.id ===null &&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' >
                                {/* begin::Heading */}
                                <Card4
                                icon='/media/imgv2/logo_light.png'
                                title=' '
                                description=''></Card4>
                              <div className="card-body card-scroll h-350px text-marino f-parrafo">

                              <div className='text-center mb-5'>
                                 <h1 className='text-dark fw-bolder mb-3'>Version <strong className='text-pink'>2.3.0</strong> (June 18, 2024)</h1>
                                 We are excited to announce a new update for our dashboard.
                                </div>

                                <div className='bg-light-info p-8 rounded'>
                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>New Filter Organization:</div>
                                  <br />
                                  <div >
                                    <p><strong>* </strong>
                                    You can now access your subscriptions and the corresponding data more easily from the top menu of the dashboard. You will only see the clouds and regions that contain data for your organization, making navigation and information management more straightforward.
                                    </p>

                                  </div>

                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>Activity Log: </div>
                                  <br />
                                  <div >
                                    <p><strong>* </strong>
                                    This new functionality allows you to view changes made in: BGP Neighbor Management, Licensing Management, Instance Management, Cluster Management, User Management, Role Management, and BGP and IPsec Segments. You can filter these changes by target, type (create, edit, delete), or by username or email. It is important to mention that each change shows in detail the history of the data created, deleted, or edited, facilitating troubleshooting and audits.                                    </p>

                                  </div>
                                 

                                </div>
                                <br />

                              <div className='text-center mb-5'>
                                 <h1 className='text-dark fw-bolder mb-3'>Version <strong className='text-pink'>2.2.0</strong> (April 19, 2024)</h1>
                                 We are excited to announce a new update for our dashboard, focused on our CTX-R.
                                </div>

                                <div className='bg-light-info p-8 rounded'>
                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>CTX-R License Management:</div>
                                  <br />
                                  <div >
                                    <p><strong>* </strong>
                                     Users now have the ability to view all their CTX-R licenses from a unified interface.
                                    Functionality has been added to edit license descriptions directly from the dashboard, making customization and organization easier.
                                    </p>

                                  </div>

                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>Associated CTX-R Visualization:</div>
                                  <br />
                                  <div >
                                    <p><strong>* </strong>
                                     Users can access a clear and detailed list of all CTX-R that belong to them, facilitating tracking and management of their resources.
                                    </p>

                                  </div>

                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>CTX-R Neighbors Management:</div>
                                  <br />
                                  <div >
                                    <p><strong>* </strong>
                                     The ability to add, delete, and edit neighbors to CTX-R with just a few clicks has been introduced.
                                    This feature provides users with finer control over their CTX-R configuration, enhancing flexibility and operational efficiency.                                    
                                    </p>

                                  </div>

                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>Neighbors Status Visualization:</div>
                                  <br />
                                  <div >
                                    <p><strong>* </strong>
                                     Now, users can easily view the status of their CTX-R neighbors, enabling quick monitoring of network connectivity and health.
                                    </p>
                                  </div>

                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>BGP and ACL Table Records:</div>
                                  <br />
                                  <div >
                                    <p><strong>* </strong>
                                     The ability to view BGP and ACL table records directly from the dashboard has been implemented, allowing for more comprehensive and detailed network monitoring.                                    </p>
                                  </div>
                                </div>
                                <br />
                              <div className='text-center mb-5'>
                                 <h1 className='text-dark fw-bolder mb-3'>Version <strong className='text-pink'>2.1.0</strong> (March 13, 2024)</h1>
                                </div>

                                <div className='bg-light-info p-8 rounded'>
                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>Bulk of IPSec Segments</div>
                                  <br />
                                  <div >
                                    <p><strong>*</strong>  This new functionality allows you to add multiple IPSec segments at the same time, just follow the structure below:</p>
                                    <p>Add the policies you want one per line in the following order separated by comma: (,).
                                     </p>
                                     <p className='text-center'> <strong>Security Policy Name,Local-ts Subnet,Remote-ts Subnet.</strong></p>
                                      <p><strong>This is an example of bulk:</strong> </p>
                                      <p> Net1-example,0.0.0.0/0,0.0.0.0/0</p>
                                      <p>Net2-example,0.0.0.0/0,0.0.0.0/0</p>
                                      <p>Net3-example,0.0.0.0/0,0.0.0.0/0</p>
                                  </div>
                                </div>
                                <br />

                              <div className='text-center mb-5'>
                                 <h1 className='text-dark fw-bolder mb-3'>Version <strong className='text-pink'>2.0.0</strong> (February 20, 2024)</h1>
                                </div>

                                <div className='bg-light-info p-8 rounded'>
                                  <div >
                                    <p>We are pleased to announce the release of the latest version of our Dashboard! In this new update, we have incorporated exciting features that will enhance your experience.</p>
                                    <p><strong>* </strong>We now have a <strong className='text-pink'> Monitoring module</strong> available to you. With this tool, you will be able to visualize the connectivity data of your CTX, as well as monitor the latency and performance of your instances.</p>
                                    <p>You have the ability to request:</p>
                                      <p><strong>* </strong><strong className='text-pink'> NGFW Module: </strong> Deploy and manage your own firewalls.</p>
                                      <p><strong>* </strong><strong className='text-pink'> CTX Reflector: </strong> Automate BGP route replication between your On-Premise networks and Public Clouds.</p>
                                    <p>Additionally, we have completely revamped the look of our dashboard. With a fresh and improved design, you can now enjoy a more attractive visual experience.</p>
                                    <p>We hope you enjoy the new version and find these improvements useful for your needs! If you have any questions or comments, please do not hesitate to contact us.</p>

                                    <p><strong>Thank you for being part of CTX!</strong></p>
                                                                                          
                                  </div>
                                </div>
                                <br />


                                <div className='text-center mb-5'>
                                 <h1 className='text-dark fw-bolder mb-3'>Version 1.6.0 (Jan 03, 2024)</h1>
                                </div>
                              
                                <div className='bg-light-info p-8 rounded'>
                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>Bulk of BGP Segments</div>
                                  <br />
                                  <div >
                                    <p><strong>*</strong>  This new functionality allows you to add multiple BGP segments at the same time, just follow the structure below:</p>
                                    <p>Enter the required prefixes you want to add to the Neighbor, one per line in the following order and separated by a comma (,).
                                     </p>
                                     <p className='text-center'> <strong>Prefix,Greater Than,Less Than,Policy(permit or denny)</strong></p>
                                      <p><strong>This is an example of bulk:</strong> </p>
                                      <p> 0.0.0.0,2,3,permit</p>
                                      <p> 0.0.0.0,4,5,permit</p>
                                      <p>0.0.0.0,6,8,permit</p>
                                      <p>0.0.0.0,9,11,deny</p>
                                      <p>0.0.0.0,13,16,deny</p>   
                                      <p><strong>If you prefer not to include the minimum and maximum intervals, follow the example:</strong></p>
                                      <p>0.0.0.0/0, , ,Permit</p>                                                                
                                  </div>
                                </div>
                                <br />



                                <div className='text-center mb-5'>
                                 <h1 className='text-dark fw-bolder mb-3'>Version 1.5.0 (Nov 23, 2023)</h1>
                                </div>
                              
                                <div className='bg-light-info p-8 rounded'>
                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>BGP Segment & IPSec Segment</div>
                                  <br />
                                  <div >
                                    <p><strong>*</strong>   This new feature allows you to view, add and delete BGP segments and  allows you to view your IPSec Segments</p>
                                  </div>
                                </div>
                                <br />



                                  <div className='text-center mb-5'>
                                     <h1 className='text-dark fw-bolder mb-3'>Version 1.4.0 (Sep 28, 2023)</h1>
                                  </div>

                                  <div className='bg-light-info p-8 rounded'>
                                    <div className='text-gray-500 fw-semibold fs-6 text-center'>CTX Documentation</div>
                                    <br />
                                    <div >
                                      <p> <strong className='text-info'>Now you can consult tutorials and information about the different functionalities of CTX Dashboard.</strong></p>
                                    </div>
                                  </div>

                                  <div className='text-center mb-5'>
                                     <h1 className='text-dark fw-bolder mb-3'>Version 1.3.0 (Sep 20, 2023)</h1>
                                  </div>

                                  <div className='bg-light-info p-8 rounded'>
                                    <div className='text-gray-500 fw-semibold fs-6 text-center'>CRUD Users and Role</div>
                                    <br />
                                    <div >
                                    <p> <strong className='text-info'>Now you can:</strong></p>
                                    <p><strong>*</strong> <strong className='text-info'>Create, Edit and Delete Users:</strong> </p>
                                    <p style={{textIndent:'10px' }}><strong>*</strong> <strong className='text-info'>Create</strong> users with the role of your choice.</p>
                                    <p style={{textIndent:'10px' }}><strong>*</strong> <strong className='text-info'>Edit</strong> the user's data and if necessary you can update the user's role.</p>
                                    <p style={{textIndent:'10px' }}><strong>*</strong> <strong className='text-info'>Delete</strong> the users you want.</p>
                                    <p ><strong>*</strong> <strong className='text-info'>Create, Edit and Delete Roles:</strong> </p>
                                    <p style={{textIndent:'10px' }}><strong>*</strong> <strong className='text-info'>Create</strong> roles with different permissions to access the dashboard.</p>
                                    <p style={{textIndent:'10px' }}><strong>*</strong> <strong className='text-info'>Edit</strong> role information by adding or removing permissions.</p>
                                    <p style={{textIndent:'10px' }}><strong>*</strong> <strong className='text-info'>Delete</strong> the roles you want.</p>
                                    <p ><strong>*</strong> View the <strong className='text-info'>Lifetime</strong> in the routing table and in the status of BGP sessions.</p>

                                    </div>
                                  </div>

                                <div className='text-center mb-5'>
                                <h1 className='text-dark fw-bolder mb-3'>Version 1.2.0 (Sep 14, 2023)</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}
                                <div className='bg-light-info p-8 rounded'>
                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>CTX Topology</div>
                                  <br />
                                  <div >
                                    <p><strong>*</strong> Now you can see the <strong className='text-info'>Topology</strong> of your CTX.</p>
                                  </div>
                                </div>
                                <br />

                                <div className='text-center mb-5'>
                                <h1 className='text-dark fw-bolder mb-3'>Version 1.1.0 (Sep 11, 2023)</h1>
                                </div>

                                <div className='bg-light-info p-8 rounded'>
                                  <div className='text-gray-500 fw-semibold fs-6 text-center'>Troubleshooting</div>
                                  <br />
                                  <div >
                                  <p><strong>*</strong> New functionality at <strong className='text-info'>Troubleshooting</strong> level, now you can perform a <strong className='text-info'>Traceroute</strong> to the IP of your choice.</p>
                                  </div>
                                </div>
                              </div>

                            </form>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }


     
      
    </>
  )
}
export {ModalVersion}